import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './globals.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import store from "./redux/store"
import Providers from './Provider';
import { registerServiceWorker } from './serviceWorkerRegistration';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
      <Providers>
        <App />
      </Providers>
      </BrowserRouter>
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register the PWA service worker so the app shell remains available offline.
// Outbox replay stays user initiated through the Sync now control.
registerServiceWorker();
